<template>
    <Loader :isActive="!hasReady"></Loader>
    <div class="config-form-content adminWeeducLayout weeduc-admin-config">
      <div class="content-wrapper primary">
        <div class="wrapper-inner">
          <div class="content-form">
            <div class="row">
                <div class="col-form-outer col-12 col-md-12 col-lg-12 " >
                 
                    <div class="col-form-inner col-12 col-md-12 col-lg-12 select">
                      <div class="form-group">
                        <label class="label-form">{{ $t('admin.siteConfig.layoutSiteType') }}</label>
                        <select v-model="layoutSite" class="select-mode">
                          <option value="1" selected>Clean</option>
                          <option value="2">Dark</option>
                        </select>
                        <small class="small">{{ $t('admin.siteConfig.layoutSiteHint') }}</small>
  
                      </div>
                    </div>
                    <div class="col-form-inner col-12 col-md-12 col-lg-12 select">
                      <div class="form-group">
                        <label class="label-form">{{ $t('admin.siteConfig.layoutPortalType') }}</label>
                        <select v-model="layoutPortal" class="select-mode">
                          <option value="1" selected>Clean</option>
                          <option value="2">Dark</option>
                        </select>
                        <small class="small">{{ $t('admin.siteConfig.layoutPortalHint') }}</small>
  
                      </div>
                    </div>
                    
                </div>
                <div class="col-form-outer col-12 col-md-12 col-lg-12 col-1">
                <div class="row">

                   
               
                  <div class="col-form-inner col-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="form-label">
                        <label>{{ $t('admin.siteConfig.css') }}</label>
                      </div>
                      <div class="form-input">
                       <textarea v-model="css"></textarea>
                       <small class="small">{{ $t('admin.siteConfig.cssLayoutHint') }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-form-outer col-12 col-md-12 col-lg-12">
                    <div class="row">
                        <div class="col-form-inner col-12 col-md-12 col-lg-12">
                            <div class="form-group">
                              <div class="form-label">
                                <label>{{ $t('admin.siteConfig.javascript') }}</label>
                              </div>
                              <div class="form-input">
                                <textarea  v-model="js"></textarea>
                                <small class="small">{{ $t('admin.siteConfig.jsLayoutHint') }}</small>

                              </div>
                            </div>
                          </div>
                    </div>
                  </div>
                 
                </div>
              </div>

             
            </div>
          </div>
        </div>
        <div class="content-button site">
          <div class="button">
            <button type="button" @click="save()" class="btn btn-block btn-content">
              {{ $t('common.save') }}
            </button>
            
          </div>
        </div>
      </div>
    </div>
    
  </template>
  
  <script>
  import api from '@/utils/site'
  import apiSiteLayout from '@/utils/Site/layout'
  import apiAWS from '@/utils/storage/aws';
  import { mapState, mapActions } from 'vuex'
  import Loader from '@/components/Loader/loader.vue'

  export default{
      data(){
          return{
            css: '',
            layoutSite: 1,
            layoutPortal: 1,
            js: '',
            hasSaved:false,
            hasReady:false,
            allCollections: [],
          }
      },
      computed:{
        ...mapState(['token'])
      },
      methods:{
   
        async getLayoutSite(){
          try {
            const response = await apiSiteLayout.getLayoutData(this.token);

            this.hasSite = true;
            this.css  = response.css;
            this.layoutSite = response.typeLayout;
            this.layoutPortal = response.typeLayoutPortal;
            this.js = response.javascript;
            this.hasReady = true;

          } catch (error) {
            console.error('Erro ao carregar as configurações de layout do Site', error)
          }
        },
        async createSite(){
          const obj = {
            "nome": this.title,
            "url": this.url,
            "title": this.title,
            "description": this.description,
            "keywords": this.keyWords,
            "logo": null,
            "favicon": null,
            "status": this.status,
            "tagManagerCode": this.tagManager,
            "typeLayout": this.layoutSite,
            "javascript": this.js,
            "css": this.css,
            "googleAnalyticsCode":this.ganalytic,
            "facebookPixelCode": this.facebook,
            "googleAdsCode":this.gads,
            "rdsecretClient": this.rdSecret,
            "rdclienteId": this.rdClient,
            "rdcode": this.rdcode,
            "rdrefreshToken": this.rdrefreshToken,
            "typeLayoutPortal": this.layoutPortal  
            
          }
          try {
            const response = api.CreateSite(this.token, obj);
          } catch (error) {
            console.error('Erro ao criar Site', error)
          }
        },
        async editSite(){
          const obj = {
            
            "typeLayout": this.layoutSite,
            "typeLayoutPortal": this.layoutPortal, 
            "javascript": this.js,
            "css": this.css,
            
          }
          try {
            const response = await apiSiteLayout.putLayoutData( this.token, obj);
            this.getLayoutSite();
            this.hasReady = true;
          } catch (error) {
            console.error('Erro ao Editar Site', error)
          }
        },
          save(){
              this.hasReady = false;
              this.editSite();
              this.hasSaved = true
              this.$emit('save', this.hasSaved)
          }
      },
      props:{
          saved: Boolean
      },
      created(){
        this.getLayoutSite();
      },
      components:{
        Loader
      }
  }
  </script>
  
<style scoped>
@import '@/css/weeduc/admin/layout.css';
</style>
  